// The player's dice colour. It lives in the account display prefs (lib/display.ts) alongside the other colour settings,
// so it's set from Account & Settings and follows the account to every device — and still works on the anonymous
// share-link table screen from that device's localStorage copy. The number colour is computed for contrast at render
// time (dice-layer.tsx `readableInk`), so `num` here is only a hint and is not used to draw the pips.
import { readDisplay, saveDisplay } from "./display";

export type DiceStyle = { id: string; label: string; body: number; num: string; metal: number; rough: number; emissive: number };

export const DICE_STYLES: DiceStyle[] = [
  { id: "brass",    label: "Brass",    body: 0xd8b45a, num: "#241a08", metal: 0.55, rough: 0.34, emissive: 0x2a1e07 },
  { id: "bone",     label: "Bone",     body: 0xece3cf, num: "#4a3d28", metal: 0.05, rough: 0.72, emissive: 0x141008 },
  { id: "obsidian", label: "Obsidian", body: 0x1b2130, num: "#d8b45a", metal: 0.35, rough: 0.38, emissive: 0x0a0d14 },
  { id: "emerald",  label: "Emerald",  body: 0x1f7a54, num: "#eafff2", metal: 0.25, rough: 0.30, emissive: 0x08281a },
  { id: "ruby",     label: "Ruby",     body: 0x9e2b3a, num: "#ffe9ec", metal: 0.25, rough: 0.30, emissive: 0x2a0a0f },
  { id: "sapphire", label: "Sapphire", body: 0x24487f, num: "#e8f0ff", metal: 0.25, rough: 0.30, emissive: 0x0a1830 },
  { id: "amethyst", label: "Amethyst", body: 0x6b3f8f, num: "#f3e9ff", metal: 0.25, rough: 0.30, emissive: 0x1a0f28 },
];

export function readDiceStyle(): DiceStyle {
  return DICE_STYLES.find((x) => x.id === readDisplay().dice) ?? DICE_STYLES[0]!;
}

/** Keep on this device, and — signed in — on the account, exactly like every other colour setting. */
export function saveDiceStyle(id: string, userId: string | null = null): void {
  void saveDisplay({ ...readDisplay(), dice: id }, userId);
}
